import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'

export default class CartApi {
  async getCartItems() {
    let query = await import('./graphql/cartItems/getCartItems.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${query}`,
      })
      .then(this.getCartItemsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  getCartItemsCallback(response) {
    let cartItems = response.data.cartItems
    Vue.prototype.$store.commit('setCartItems', cartItems)
    return response
  }

  async addToCartMutation(resourceIds) {
    let addToCart = await import('./graphql/cartItems/addToCartMutation.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${addToCart}`,
        variables: {resourceIds}
      })
      .then(this.addToCartMutationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  addToCartMutationCallback(result) {
    let cartItem = result.data.addToCart
    Vue.prototype.$store.commit('addCartItem', cartItem)
    return cartItem
  }

  async deleteCartItemsMutation(ids) {
    let deleteCartItems = await import('./graphql/cartItems/deleteCartItemsMutation.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${deleteCartItems}`,
        variables: {ids}
      })
      .then(this.deleteCartItemsMutationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  deleteCartItemsMutationCallback(result) {
    let response_data = result.data.deleteCartItems
    Vue.prototype.$store.commit('deleteCartItems', response_data)
  }

  async createCartMutation(name, cpv, edi, comm) {
    let createCart = await import('./graphql/cartItems/createCartMutation.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${createCart}`,
        variables: {name: name, cpv: cpv, edi: edi, comment: comm}
      })
      .then(this.createCartMutationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  createCartMutationCallback(result) {
    let cartItem = result.data.createCart

    Vue.prototype.$store.commit('addCartItem', cartItem)
    return cartItem
  }
}
